export default __webpack_public_path__ + "static/media/What_is_DCash.17b1a5cc.jpg";